import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useNewsAndGuidesDetailsPageData } from '#src/app/pages/newsAndGuides/details/pageContext';
import { useLocale } from '#src/app/shared/hooks/l10n';
import { useSessionUuid } from '#src/app/shared/hooks/session';
import type { ShareAction } from '#src/app/shared/hooks/share';
import { useShareActions } from '#src/app/shared/hooks/share';

import { getNewsAndGuidesShareLinks } from './api';
import { useShareOptions } from './useShareOptions';

export type { Channel } from './types';

const QUERY_KEY = 'news-and-guides-share-links';

type Result = ModelHookResult<{
	shareActions: readonly ShareAction[];
	isLoading: boolean;
}>;

export function useShareLinks(): Result {
	const {
		data: {
			countryCode,
			details: { slug },
		},
	} = useNewsAndGuidesDetailsPageData();
	const locale = useLocale();
	const sessionUuid = useSessionUuid();
	const utilityContext = useUtilityContext();
	const options = useShareOptions();

	const { data, isLoading } = useQuery({
		queryKey: [QUERY_KEY, { countryCode, locale, slug, sessionUuid }],
		queryFn: async () => getNewsAndGuidesShareLinks({ countryCode, locale, slugOrId: slug }, utilityContext),
	});

	return {
		data: {
			shareActions: useShareActions(data?.links ?? [], options),
			isLoading: isLoading && !data,
		},
	};
}
